import {useMemo, useTransition} from 'react';

import {MergedProduct} from '../context/types';
import {useSearchParams} from '@remix-run/react';

export const useSearchParamOptions = (product: MergedProduct) => {
  const transition = useTransition();
  const [currentSearchParams] = useSearchParams();
  const searchParams = useMemo(() => {
    return transition.location
      ? new URLSearchParams(transition.location.search)
      : currentSearchParams;
  }, [currentSearchParams, transition]);

  const selected = product?.selectedVariant || product?.variants?.[0];

  const searchParamsWithDefaults = useMemo<URLSearchParams>(() => {
    const clonedParams = new URLSearchParams(searchParams);
    if (!selected) {
      return new URLSearchParams();
    }
    for (const {name, value} of selected.selectedOptions || []) {
      if (!searchParams.has(name)) {
        clonedParams.set(name, value);
      }
    }

    return clonedParams;
  }, [searchParams, selected]);

  return {
    searchParamsWithDefaults,
  };
};
